<template>
  <div>
    <h1>Listado de siniestros para extranet</h1>

    <filter-sinisters @change="fetchSinisters"></filter-sinisters>

    <selected-sinisters-summary :items="selectedSinisters" @save="submitPackage"></selected-sinisters-summary>

    <table-actions
      :tableHeaders="headers"
      title="Siniestros para armado de paquetes"
      :tableData="sinisterList"
      @selected="onSelected"
    ></table-actions>
  </div>
</template>

<script>
import ExtranetService from "../../services/extranet";

import TableActions from "./TableActions";
import FilterSinisters from "./FilterSinisters";
import SelectedSinistersSummary from "./SelectedSinistersSummary";

export default {
  name: "SinisterPackage",
  components: {
    TableActions,
    FilterSinisters,
    SelectedSinistersSummary,
  },
  data() {
    return {
      headers: [
        { text: "Número de requisición", value: "requisitionNumber" },
        { text: "Cliente", value: "highway" },
        { text: "Folio", value: "folio" },
        { text: "Total", value: "total" },
        { text: "UUID", value: "uuid" },
      ],
      sinisterList: [],
      selectedSinisters: [],
      dollarPrice: 0,
    };
  },
  methods: {
    onSelected(items) {
      this.selectedSinisters = items;
    },
    fetchSinisters(params) {
      ExtranetService.fetchSinisters(params).then((response) => {
        this.sinisterList = response;
      });
    },
    submitPackage(dolar) {
      if (this.selectedSinisters.length === 0) {
        this.$alertMessage({
          title: "Favor de seleccionar al menos un siniestro",
        });
      } else {
        ExtranetService.sendSinisterPackage(this.selectedSinisters, dolar)
          .then((response) => {
            this.$successMessage({
              title: `Se generó el paquete con folio: ${response.folio}`,
            });
            this.$router.push({ name: "Seguimiento de paquetes" });
          })
          .catch(this.$fireErrorResponse);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card {
  z-index: unset;
}
</style>


// WEBPACK FOOTER //
// src/pages/extranet/SinisterPackages.vue